// extracted by mini-css-extract-plugin
module.exports = {"box":"content_box__3KVlf","content":"content_content__eyxmq","section":"content_section__3Jder","title":"content_title__25nq3","inner":"content_inner__38G4y"};